import { ShowContentChangeRequest } from './show-content-change-request';

export default ShowContentChangeRequest;